import ReverificationOverviewDev from './ReverificationOverviewDev';
import CollegeOverviewDev from './CollegeOverviewDev';

export default function ReverificationDashboardDev() {


    return (
        <>
            <ReverificationOverviewDev />
            <CollegeOverviewDev />
        </>
    )
}